import React from 'react'

export type Badge = {
  slug: string
  name: string
}

const BadgePills: React.FC<{ badges?: Badge[]; className?: string }> = ({ badges, className }) => {
  if (!badges || badges.length === 0) return null

  return (
    <div className={['flex flex-wrap gap-2', className].filter(Boolean).join(' ')}>
      {badges.map((b) => (
        <span
          key={b.slug}
          className={'badge badge_' + b.slug}
        >
          {b.name || b.slug}
        </span>
      ))}
    </div>
  )
}

export default BadgePills
